import { IntentPage } from "../components/IntentPage/IntentPage";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";

const SegmentationSurveyPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <IntentPage />
    </UnderMaintenanceOrChildren>
  );
};

export default SegmentationSurveyPage;
